import React, { useEffect, useState } from 'react';

import RadioButton from 'components/shared/RadioButton/RadioButton';

const RadioSelectCell = ({ node, api }) => {
  const [isSelected, setIsSelected] = useState(node.isSelected());

  useEffect(() => {
    const onSelectionChanged = () => {
      setIsSelected(node.isSelected());
    };

    api.addEventListener('selectionChanged', onSelectionChanged);

    return () => {
      api.removeEventListener('selectionChanged', onSelectionChanged);
    };
  }, [api, node]);

  const handleChange = () => {
    node.setSelected(!isSelected);
  };

  return (
    <div className="flex h-full items-center justify-center">
      <RadioButton
        size={16}
        id={`select-${node.id}`}
        label=""
        rounded
        isSelected={isSelected}
        onChange={handleChange}
      />
    </div>
  );
};

export default RadioSelectCell;
